module.exports = __webpack_public_path__ + "img/list-grey.f3d2f6fa.svg";